module.exports = __webpack_public_path__ + "media/images/common/lp/bg-ctaBox__heading--left-a08d73ff1d2aa7059290f42d83a9f808.png";